import React from 'react';
import Modal from './Modal';
import './HowToPlay.css';

interface HowToPlayProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowToPlay: React.FC<HowToPlayProps> = ({ isOpen, onClose }) => {
  return (
    <Modal title="How to Play" isOpen={isOpen} onClose={onClose}>
      <div className="howtoplay-body">
        <div className="content-section">
          <h3>Core Rules</h3>
          <ul>
            <li>Guess letters to reveal the hidden word</li>
            <li>Win by revealing the entire word before running out of guesses</li>
            <li>You have 6 tries per word, but correct guesses do not count against you</li>
            <li>Some letters may be automatically revealed</li>
            <li>Score = number of guesses remaining when you win</li>
          </ul>
        </div>

        <div className="content-section">
          <h3>Game Modes</h3>
          <div className="game-modes">
            <div className="mode-card">
              <h4>Daily Challenge</h4>
              <ul>
                <li>Six words daily (5-10 letters)</li>
                <li>Same challenge for everyone</li>
                <li>Progress is saved</li>
                <li>Daily score = sum of all words</li>
              </ul>
            </div>

            <div className="mode-card">
              <h4>Free Play</h4>
              <ul>
                <li>Choose Word Packs for themed gameplay</li>
                <li>Toggle RSTLNE mode on/off</li>
                <li>Play unlimited games</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HowToPlay;
